import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMtaComponent } from './simple-icons-mta.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMtaComponent ],
    exports:      [ SimpleIconsMtaComponent ],
    bootstrap:    []
})
export class SimpleIconsMtaModule {}
